import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'ngx-dialog',
    styleUrls: ['./image-dialog.component.scss'],
    templateUrl: './image-dialog.component.html',
    standalone: false
})
export class ImageDialogComponent  {
  @Input() imgUrl: string;
  @Output() isClosed = new EventEmitter<boolean>(false);

  constructor() {}

  cancel() {
    this.isClosed.emit(true);
  }
}
